import { instance } from "../axios/axiosConfig";

const helpApi = {
  fetchSubjects() {
    return instance.get(`/api/contact-us/`);
  },
  setContactUs(body: FormData) {
    return instance.post(`/api/contact-us/`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};

export default helpApi;
